// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15oO-","colMin":"styles_colMin__-u8rR"};